var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticStyle: { margin: "12px" } },
      [
        _c(
          "el-radio-group",
          {
            on: { change: _vm.changeJumpUrl },
            model: {
              value: _vm.insuranceAgent,
              callback: function($$v) {
                _vm.insuranceAgent = $$v
              },
              expression: "insuranceAgent"
            }
          },
          _vm._l(_vm.insuranceAgents, function(option) {
            return _c(
              "el-radio",
              { key: option.code, attrs: { label: option.code } },
              [_vm._v(_vm._s(option.chineseName))]
            )
          }),
          1
        )
      ],
      1
    ),
    _c("div", { staticStyle: { "flex-grow": "1" } }, [
      _c("iframe", {
        ref: "myIframe",
        style: { border: "none", marginLeft: "10px" },
        attrs: {
          "same-site": "none",
          src: _vm.innerJumpUrl,
          width: "99%",
          height: "98%"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }